import { Controller } from "@hotwired/stimulus";

// Drives the in-app changelog ("What's new").
//
// Lives on .pusher#app so both the sidebar entry point (with its unseen dot)
// and the modal are inside its scope. Responsibilities:
//   - open the Fomantic modal from the sidebar item or the toast pill
//   - stamp the per-user seen-watermark (POST /changelog/seen) when opened or
//     dismissed, so the dot clears and a notify entry won't toast again
//   - slide in the bottom toast pill once. The pill is only server-rendered when
//     a notify-flagged entry is pending, so its presence IS the signal to show.
export default class extends Controller {
  static targets = ["dot", "pill"];
  static values = {
    modal: { type: String, default: "#changelog-modal" },
  };

  connect() {
    if (this.hasPillTarget) {
      // Let the page settle, then slide the pill in.
      this._timer = setTimeout(() => {
        this.pillTarget.classList.add("changelog-toast--visible");
      }, 900);
    }
  }

  disconnect() {
    if (this._timer) clearTimeout(this._timer);
  }

  // Sidebar item / toast pill click -> open the modal.
  open(event) {
    if (event) event.preventDefault();
    const $ = window.$;
    if ($) {
      // Let Fomantic lift the modal to a body-level dimmer (detachable default).
      // Rendered in place inside .pusher#app (overflow:hidden + its own z-index
      // context) the modal stacked *below* the dimmer overlay.
      $(this.modalValue).modal({ duration: 200, observeChanges: true }).modal("show");
    }
    this._markSeen();
    this._clearIndicators();
  }

  // Toast pill "x" -> acknowledge without opening.
  dismiss(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this._markSeen();
    this._clearIndicators();
  }

  _clearIndicators() {
    this.dotTargets.forEach((el) => (el.style.display = "none"));
    if (this.hasPillTarget) {
      this.pillTarget.classList.remove("changelog-toast--visible");
    }
  }

  _markSeen() {
    if (this._seen) return;
    this._seen = true;
    const csrf =
      document.querySelector('meta[name="csrf-token"]')?.content || "";
    fetch("/changelog/seen", {
      method: "POST",
      headers: { "X-CSRF-Token": csrf, Accept: "application/json" },
      credentials: "same-origin",
    }).catch(() => {});
  }
}
